import { Skeleton } from '@/components/ui/skeleton';

export const ApiKeysSkeleton = () => {
  return (
    <div className='p-4 w-full mx-auto'>
      <div className='animate-pulse flex space-x-4'>
        <div className='flex-1 space-y-6 py-1'>
          <div className='grid grid-cols-3 gap-4'>
            <Skeleton className='h-8 rounded col-span-2' />
            <Skeleton className='h-8 rounded col-span-1' />
          </div>
          <Skeleton className='h-32 rounded col-span-1' />
          <Skeleton className='h-32 rounded col-span-1' />
        </div>
      </div>
    </div>
  );
};
